import { Field, Text } from "@sitecore-jss/sitecore-jss-react";
import React, { useState } from "react";

import { fetchMortgageList } from "../../../api/dlp";
import { useDidMount } from "../../../hooks/useDidMount";
import { ModelState } from "../../../interfaces/modelState";
import { DlpState } from "../../../providers/dlpFlow/DlpFlow.interfaces";
import { Card } from "../../card/Card";
import { SelectionListInput } from "../../InputFields/SelectionListInput";
import SwitchInput from "../../InputFields/SwitchInput";

interface MortgageSupplier {
  key: string;
  value: string;
}

interface Props {
  fields: Record<string, Field<string>>;
  data: DlpState;
  modelState: ModelState | null;
  onUpdateHasMortgage: (hasMortgage: boolean) => void;
  onUpdateMortgageSupplierKey: (mortgageSupplierKey: string, mortgageSupplierLabel: string) => void;
}

export const MortgageSelection = ({
  fields,
  data,
  onUpdateHasMortgage,
  onUpdateMortgageSupplierKey,
  modelState,
}: Props) => {
  const [mortgageList, setMortgageList] = useState<MortgageSupplier[] | undefined>(undefined);

  const handleMortgageSelection = (value: string) => {
    const mortgageSupplierLabel = mortgageList?.find((ml) => ml.key === value)?.value;
    if (mortgageSupplierLabel) {
      onUpdateMortgageSupplierKey(value, mortgageSupplierLabel);
    }
  };

  useDidMount(async () => {
    try {
      const mortgageSuppliers = await fetchMortgageList();
      setMortgageList(
        mortgageSuppliers.map((supplier) => ({ key: supplier.supplierId, value: supplier.supplierName }))
      );
    } catch {
      // ignore errors
    }
  });

  return (
    <Card>
      <h2>
        <Text field={fields.HeadingMortgage} />
      </h2>

      <SwitchInput
        fieldData={fields}
        value={data.hasMortgage === "Yes" ? true : false}
        name="SwitchMortgage"
        id="switch_mortgage"
        fieldName="SwitchMortgage"
        onChange={onUpdateHasMortgage}
      />
      {data.hasMortgage === "Yes" && mortgageList && (
        <SelectionListInput
          fieldData={fields}
          options={mortgageList}
          value={data.mortgageSupplierKey}
          name="SelectionListInput"
          id="selection_list_input"
          propertyName="model.MortgageSupplierKey"
          fieldName="SelectionListInput"
          onChange={handleMortgageSelection}
          modelState={modelState}
        />
      )}
    </Card>
  );
};
